import React, { useEffect, useState } from "react";
import DataGrid, {
	Column,
	Paging,
	FilterRow,
	HeaderFilter,
} from "devextreme-react/data-grid";
import { Popup } from "devextreme-react/popup";
import { Button } from "devextreme-react/button";
import { getUserOrders, refundUserOrder } from "../api/apiServiceFetch";

const OrderPopup = ({ userId, visible, onClose }) => {
	const [orders, setOrders] = useState([]);
	const [refundingId, setRefundingId] = useState(null);

	useEffect(() => {
		const fetchOrders = async () => {
			if (userId && visible) {
				try {
					const data = await getUserOrders(userId);
					setOrders(data);
				} catch (err) {
					console.error("Ошибка загрузки заказов пользователя:", err);
				}
			}
		};
		fetchOrders();
	}, [userId, visible]);

	const handleRefund = async (order) => {
		if (!order?.id) return;
		if (!window.confirm(`Сделать возврат по заказу #${order.id}?`)) return;
		setRefundingId(order.id);
		try {
			const resp = await refundUserOrder(order.id);
			alert("Возврат отправлен: " + JSON.stringify(resp));
			const data = await getUserOrders(userId);
			setOrders(data);
		} catch (err) {
			alert("Ошибка возврата: " + (err?.message || err));
		} finally {
			setRefundingId(null);
		}
	};

	if (!visible) return null;

	return (
		<Popup
			visible={true}
			onHiding={onClose}
			dragEnabled={true}
			showTitle={true}
			title="Заказы пользователя"
			width={1100}
			height={500}
		>
			<DataGrid dataSource={orders} keyExpr="id" showBorders={true}>
				<Paging defaultPageSize={10} />
				<FilterRow visible={true} />
				<HeaderFilter visible={true} />
				<Column dataField="id" caption="ID" width={80} />
				<Column dataField="uuId" caption="UUID" width={100} />
				<Column dataField="paymentId" caption="PaymentId" width={140} />
				<Column
					dataField="type"
					caption="Тип"
					calculateCellValue={(data) => {
						switch (data.type) {
							case 1:
								return "Platinum 💎";
							case 2:
								return "Super 🚀";
							case 3:
								return "Чистый лист 🆕";
							case 4:
								return "Инкогнито";
							case 5:
								return "Повторная регистрация 🔄";
							default:
								return data.type;
						}
					}}
				/>

				<Column
					dataField="payType"
					caption="Метод"
					calculateCellValue={(data) => {
						switch (data.payType) {
							case 1:
								return "Подарок 🎁";
							case 2:
								return "ТБанк 🏦";
							case 3:
								return "Звёзды ⭐";
							default:
								return data.payType;
						}
					}}
					width={100}
				/>
				<Column dataField="price" caption="Цена" />
				<Column dataField="superLikes" caption="Суперлайки" />
				<Column dataField="payLink" caption="Ссылка" />
				<Column
					dataField="createDate"
					caption="Создан"
					dataType="date"
					format="dd.MM.yyyy"
				/>
				<Column
					dataField="endDate"
					caption="Окончание"
					dataType="date"
					format="dd.MM.yyyy"
				/>
				<Column
					caption="Действие"
					width={140}
					cellRender={({ data }) => {
						if (data.payType !== 2) return null;
						if (!data.paymentId) {
							return (
								<span style={{ color: "#999", fontSize: 12 }}>нет paymentId</span>
							);
						}
						return (
							<Button
								text={refundingId === data.id ? "..." : "Возврат"}
								disabled={refundingId === data.id}
								onClick={() => handleRefund(data)}
								stylingMode="contained"
								type="danger"
							/>
						);
					}}
				/>
			</DataGrid>

			<div style={{ textAlign: "right", marginTop: 10 }}>
				<Button text="Закрыть" onClick={onClose} />
			</div>
		</Popup>
	);
};

export default OrderPopup;
